"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Generated from cz.marbes.pdfviewer.controller.PdfViewerController.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:38:56Z                      #

// ##############################################################

var PdfViewerApi = function () {
  function PdfViewerApi() {
    (0, _classCallCheck3.default)(this, PdfViewerApi);
  }

  (0, _createClass3.default)(PdfViewerApi, null, [{
    key: "getView",

    /**
     * 
     *
     * @param viewId 
     * @return 
     */
    value: function getView(viewId) {
      var uri = serverContextPath + ("/api/pdfViewer/" + viewId);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param viewId 
     * @param documentId 
     * @return 
     */

  }, {
    key: "getDocumentMeta",
    value: function getDocumentMeta(viewId, documentId) {
      var uri = serverContextPath + ("/api/pdfViewer/" + viewId + "/" + documentId + "/meta");
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param viewId 
     * @param documentId 
     * @param originalFile 
     */

  }, {
    key: "getDocumentFile",
    value: function getDocumentFile(viewId, documentId, originalFile) {
      var uri = serverContextPath + ("/api/pdfViewer/" + viewId + "/" + documentId + "/file");
      var headers = undefined;
      var params = { originalFile: originalFile };

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param viewId 
     */

  }, {
    key: "removeView",
    value: function removeView(viewId) {
      var uri = serverContextPath + ("/pdfViewer/" + viewId);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.delete(uri, params));
    }
  }]);
  return PdfViewerApi;
}();

exports.default = PdfViewerApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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